/**
 * Imports the default themes for all components and extensions
 *
 */

import '../theme-ui/ui-theme-components.scss'
import '../theme-ui/ui-theme-basis.scss'
